import { TeamCreditsService } from './../_services/team-credits.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GlobalService } from '../_services/global.service';
import moment from 'moment';
import { TeamManagementService } from '../_services/new-settings/team-management.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-teaminvite',
    templateUrl: './teaminvite.component.html',
    styleUrls: ['./teaminvite.component.scss'],
    standalone: false
})
export class TeaminviteComponent implements OnInit {
  admin_emailid: any;
  admin_name: any;
  expiry_time: any;
  errorMessage: any;
  invalidurl: boolean = false;
  successMessage: string = '';
  showInviteSpinner: Boolean = false
  showInvitationData: any[] = [];
  userdata: any;
  acceptInvitationModelRef: any;
  invitedWithLink: boolean = false;
  infoMessage: string = '';

  @ViewChild('acceptInvitationModel') acceptInvitationModel: TemplateRef<any>;
  @ViewChild('remindLaterInvitationModel') remindLaterInvitationModel: TemplateRef<any>;
  @ViewChild('invitationModel') invitationModel: any;

  constructor(
    private Route: ActivatedRoute,
    private teamservice: TeamCreditsService,
    private router: Router,
    private modalService: NgbModal,
    private teammanagementservice: TeamManagementService,
    private _localstorageservice: LocalStorageService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {


    this.userdata = this._localstorageservice.getItem('userdata')
    const data = JSON.parse(localStorage.getItem('teaminviteurl')) || [];
    if(data && data.openWithLink) {
      this.invitedWithLink = true;
      this.showInvitationData = data.urlArray || [];
    } else {
      this.showInvitationData = data || [];
    }

    this.showInviteDetails();

    // this.Route.queryParams.subscribe(params => {
    //   this.admin_emailid = GlobalService.decryptData(params['tokense']);
    //   this.admin_name = GlobalService.decryptData(params['tokenun']);
    //   this.expiry_time = GlobalService.decryptData(params['tokenv']);
    // });

    // let start = moment(this.expiry_time);
    // let end = moment(new Date());
    // let duration = moment.duration(start.diff(end));
    // let hours = duration.asHours();
    // if (hours > 8) {
    //   this.invalidurl = true
    //   this.errorMessage = 'Link has expired'
    //   setTimeout(() => {
    //     this.errorMessage = ''
    //     this.router.navigateByUrl('/searchtoolbox-v2')
    //   }, 5000);
    // }
  }


  /**
   * Show Invitation Admin Details
   */
  showInviteDetails() {
    if (this.showInvitationData && this.showInvitationData.length) {
      let url = this.showInvitationData[0]

      const queryString = url.split('?')[1];
      const pairs = queryString.split('&');
      const params: any = {};
      pairs.forEach((pair: string) => {
        const [key, value] = pair.split('=');
        params[key] = value;
      });

      this.admin_emailid = GlobalService.decryptData(params['tokense']);
      this.admin_name = GlobalService.decryptData(params['tokenun']);
      this.expiry_time = GlobalService.decryptData(params['tokenv']);
    } else {
      localStorage.removeItem('teaminviteurl');
      this.activeModal.dismiss();
       this.showInviteSpinner = false;
    this.acceptInvitationModelRef = false;

     // this.dismiss();
    }
  }


  /**
  * Reject Invitation Model
  */
  openRemindLaterInvitationModel() {
    this.modalService.open(this.remindLaterInvitationModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Accept invitation Model
   */
  openConfirmInvitationModel() {
    this.acceptInvitationModelRef =  this.modalService.open(this.acceptInvitationModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Response on join team invitation
   * @param type
   */
  acceptApplication(type: string) {
    if (!this.invalidurl) {
        this.showInviteSpinner = true;
      let data = {
        teamadminemailid: this.admin_emailid,
        invitestatus: type
      }
      this.teamservice.inviteresponse(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.successMessage = 'Invitation Accepted Successfully!';
          setTimeout(() => this.successMessage = '', 5000);
          this.acceptInvitationModelRef.dismiss();
        } else if (res.status == 'failure' && res.message == 'User is already part of some team') {
          this.infoMessage = 'You are already part of a team, Leave the team to accept the invitation.!';
          setTimeout(() => this.infoMessage = '', 5000);
        } else if (res.status == 'failure' && res.message == 'User is already team admin') {
          this.infoMessage = 'You are already part of a team, Leave the team to accept the invitation.!';
          setTimeout(() => this.infoMessage = '', 5000);
        } else {
          this.errorMessage = 'Something went wrong'
          setTimeout(() => this.errorMessage = '', 5000);
        }
        this.showInviteSpinner = false;
        setTimeout(()=>{
          this.dismiss();
          localStorage.removeItem('teaminviteurl')
          this.router.navigateByUrl('/settings/team-management')
        }, 5000);
      })
    }
  }

  /**
   * Remind Later
   * @param type
   */
  remindLaterInvitation(type: string) {
    if (!this.invalidurl) {
      let data = {
        teamadminemailid: this.admin_emailid,
        invitestatus: type
      }
      this.showInviteSpinner = true;
      this.teammanagementservice.remindLater(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.successMessage = 'Will remind you latter';
          setTimeout(() => this.successMessage = '', 5000);
          this.showInvitationData = this.showInvitationData.slice(1);
          this.showInviteDetails();
          if (this.showInvitationData.length === 0) {
            this.router.navigateByUrl('/settings/team-management');
            this.dismiss();
          }
        } else {
          this.errorMessage = 'Something went wrong'
          setTimeout(() => {
            this.errorMessage = ''
            this.router.navigateByUrl('/settings/team-management')
          }, 5000);
          this.dismiss();
        }
        this.showInviteSpinner = false;

      })
    }
  }

  /**
   * Skip Invite
   */
  skipInvite() {
    this.dismiss();
    localStorage.removeItem('teaminviteurl')
  };

  /**
   * Dismiss Model
   */
  dismiss() {
    this.modalService.dismissAll();
    this.showInviteSpinner = false;
    this.acceptInvitationModelRef = false;
  };


}
